// Screen definition: Conversaciones
// Client-side pagination
import type { ScreenDefinition } from '@/types/screen-definition';

export const conversacionScreenDef: ScreenDefinition = {
  id: 'conversaciones',
  title: 'Conversaciones',
  itemLabel: 'conversaciones',

  columns: [
    {
      key: 'cliente',
      header: 'Cliente',
      type: 'custom', // Avatar + name + company subtitle
      locked: true,
      sortable: false,
    },
    {
      key: 'asunto',
      header: 'Asunto',
      type: 'custom', // Title + message preview
    },
    {
      key: 'estado',
      header: 'Estado',
      type: 'custom', // StatusBadge + unread count badge
    },
    {
      key: 'asignado_a',
      header: 'Asignado',
      type: 'text',
      sortable: false,
      defaultVisible: false,
      config: { muted: true, fallback: 'Sin asignar' },
    },
    {
      key: 'ultimo_mensaje_at',
      header: 'Último mensaje',
      type: 'date',
      config: { format: 'relative' },
    },
  ],

  defaultSort: { field: 'ultimo_mensaje_at', order: 'desc' },

  pagination: {
    mode: 'client',
    defaultPageSize: 25,
  },

  search: {
    enabled: true,
    placeholder: 'Buscar conversaciones...',
  },

  quickFilters: [
    {
      key: 'estado',
      options: [
        { value: 'NUEVA', label: 'Nueva' },
        { value: 'ESPERA_SOPORTE', label: 'Espera Soporte' },
        { value: 'ESPERA_CLIENTE', label: 'Espera Cliente' },
        { value: 'EN_PAUSA', label: 'En Pausa' },
        { value: 'CERRADA', label: 'Cerrada' },
      ],
    },
  ],

  rowClick: { type: 'navigate', path: '/conversaciones/:id' },

  empty: {
    message: 'No se encontraron conversaciones',
    icon: 'MessageSquare',
  },
};
